import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getCustomers } from '../../../services/userService';

const { TextArea } = Input;
const { Option } = Select;

const BatchCreateModal = ({
  visible,
  onCancel,
  onOk,
  batchNumber,
  orderIds,
  onBatchNumberChange,
  onOrderIdsChange,
  onCustomerChange,
  selectedCustomer
}) => {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const data = await getCustomers();
        setCustomers(data);
      } catch (error) {
        console.error('Error fetching customers:', error);
      }
    };

    if (visible) {
      fetchCustomers();
    }
  }, [visible]);

  return (
    <Modal
      title={
        <span>
          <PlusOutlined style={{ marginRight: 8 }} />
          批量添加批次号
        </span>
      }
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form layout="vertical">
        <Form.Item label="客户" required>
          <Select
            placeholder="选择客户"
            value={selectedCustomer}
            onChange={onCustomerChange}
          >
            {customers.map(customer => (
              <Option key={customer.id} value={customer.id}>
                {customer.company_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="批次号">
          <Input
            placeholder="输入批次号"
            value={batchNumber}
            onChange={(e) => onBatchNumberChange(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="订单号列表">
          <TextArea
            placeholder="每行一个订单号或快递单号"
            value={orderIds}
            onChange={(e) => onOrderIdsChange(e.target.value)}
            rows={6}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BatchCreateModal;
